import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-video-streams",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./video-streams.component.html",
  styleUrl: "./video-streams.component.scss",
})
export class VideoStreamsComponent implements AfterViewInit, OnChanges {
  @ViewChild("remoteVideo")
  private remoteVideoRef?: ElementRef<HTMLVideoElement>;
  @ViewChild("localVideo") private localVideoRef?: ElementRef<HTMLVideoElement>;

  @Input() localStream: MediaStream | null = null;
  @Input() remoteStream: MediaStream | null = null;

  ngAfterViewInit(): void {
    this.applyStream(this.localVideoRef, this.localStream);
    this.applyStream(this.remoteVideoRef, this.remoteStream);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["localStream"]) {
      this.applyStream(this.localVideoRef, this.localStream);
    }
    if (changes["remoteStream"]) {
      this.applyStream(this.remoteVideoRef, this.remoteStream);
    }
  }

  private applyStream(
    ref: ElementRef<HTMLVideoElement> | undefined,
    stream: MediaStream | null,
  ): void {
    if (!ref) return;

    const isLocal = ref === this.localVideoRef;
    if (isLocal) {
      ref.nativeElement.muted = true;
      ref.nativeElement.defaultMuted = true;
      ref.nativeElement.volume = 0;
    } else {
      ref.nativeElement.muted = false;
      ref.nativeElement.volume = 1;
    }

    ref.nativeElement.srcObject = stream;
  }
}
